import React from 'react'
import { useTranslation } from 'react-i18next'
import { Control, FieldErrors } from 'react-hook-form'
import { Typography } from '@material-ui/core'
import { ControlledTextField } from '../../../form/ControlledTextField'
import { validators } from '../../../../validation/validators'
import { InternalFormValues } from '../form-values'
import { FormGroup } from '../../../form/FormGroup'
import { powerUnit } from '../../../../util/formatters'
import { ControlledHourSeriesSelect } from '../../../form/ControlledHourSeriesSelect'
import {
  HourSeriesCollectionFragment,
  HourSeriesType,
} from '../../../../generated/graphql'

type Props = {
  control: Control<InternalFormValues>
  errors: FieldErrors<InternalFormValues>
  hourSeriesCollections: HourSeriesCollectionFragment[]
}

export function CirculationHeatPumpForm({
  control,
  errors,
  hourSeriesCollections,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <>
      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.circulationHeatPump.cop"
          rules={{
            ...validators.required,
            ...validators.cop,
          }}
          error={errors.parameters?.circulationHeatPump?.cop}
          label={t('createProvider.forms.circulationHeatPump.cop')}
        />
      </FormGroup>

      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.circulationHeatPump.maxPower"
          rules={{
            ...validators.required,
            ...validators.maxPower,
          }}
          error={errors.parameters?.circulationHeatPump?.maxPower}
          label={t('createProvider.forms.circulationHeatPump.maxPower')}
          InputProps={{
            endAdornment: <Typography>{powerUnit}</Typography>,
          }}
        />
      </FormGroup>

      <FormGroup>
        <ControlledHourSeriesSelect
          control={control}
          name="hourSeriesIds"
          error={errors.hourSeriesIds}
          label={t('createProvider.forms.circulationHeatPump.hourSeries')}
          collections={hourSeriesCollections}
          filter={(hourSeries) =>
            hourSeries.type === HourSeriesType.WasteHeating
          }
          allowEmpty
        />
      </FormGroup>
    </>
  )
}
